<template #row-details="row">
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="grayDiv">
      <b-row>
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-form-group label="Email" label-align="left" class="boldTxt">
            <b-form-input
                v-model="correoOriginal"
                type="email"
                :required="!pacienteOriginalExtranjero"
                :state="correoOriginal != '' && correoOriginal != null && !pacienteOriginalExtranjero"
                v-on:change="nuevoEmail"
            ></b-form-input>
          </b-form-group>
          <b-form-invalid-feedback
              :state="correoOriginal != '' && correoOriginal != null && !pacienteOriginalExtranjero"
          >
            Se debe colocar un correo.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6" lg="4" xl="4" v-for="(itm, index) in this.telefonos" :key="index" :value="index">
           <span>
        <b-form-group
            :label="'Teléfono ' + itm.tipo"
            label-align="left"
            class="boldTxt"
            v-on:change="nuevosTelefonos"
        >
          <b-form-input v-if="itm.tipo == 'celular'"
                        v-on:keypress="esNumero($event)"
              v-model="itm.numero" type="number"
              :required="itm.tipo == 'celular' && !pacienteOriginalExtranjero"
              :state="itm.numero != '' && itm.numero != null && itm.tipo == 'celular' && !pacienteOriginalExtranjero && itm.numero.length >=10"
              maxlength="10" oninput="
              if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);
              this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
          ></b-form-input>
          <b-form-input v-else
                        v-on:keypress="esNumero($event)"
              v-model="itm.numero" type="number"
              maxlength="10" oninput="
              if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);
              this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
          ></b-form-input>
        </b-form-group>
             <b-form-invalid-feedback
                 v-if="itm.tipo == 'celular'"
                 :state="itm.numero != '' && itm.numero != null && itm.tipo == 'celular' && !pacienteOriginalExtranjero && itm.numero.length >=10"
             >
            Se debe colocar un teléfono celular.
          </b-form-invalid-feedback>
      </span>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col>
        <label>Historia clínica</label>
        <b-form-group>
          <b-form-radio-group
              v-model="historiaSeleccionada"
              :options="historias"
              text-field="descripcion"
              value-field="idPaciente"
              required
              :state="historiaSeleccionada != null"
              stacked
          >
          </b-form-radio-group>
        </b-form-group>
        <b-form-invalid-feedback
            :state="historiaSeleccionada != null"
        >
          Se debe seleccionar una historia completa. En caso de no contar con historia clínica, favor de registrarla para poder continuar.
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <b-row v-if="ptis.length > 0">
      <b-col>
        <label>PTI</label>
        <b-form-group>
          <b-form-radio-group
              v-model="ptiSeleccionado"
              :options="ptis"
              required
              :state="ptiSeleccionado != null"
          >
          </b-form-radio-group>
        </b-form-group>
        <b-form-invalid-feedback
            :state="ptiSeleccionado != null"
        >
          Se debe seleccionar el PTI de un paciente para poder continuar.
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <b-row v-if="kpis.length > 0">
      <b-col>
        <label>Citas</label>
        <b-form-group>
          <b-form-radio-group
              v-model="kpiSeleccionado"
              :options="kpis"
              required
              :state="kpiSeleccionado != null"
          >
          </b-form-radio-group>
        </b-form-group>
        <b-form-invalid-feedback
            :state="kpiSeleccionado != null"
        >
          Se debe seleccionar un paciente para poder continuar.
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12" md="4" lg="4" xl="4" v-for="px in infoPacienteDuplicado" :key="px.id">
        <label style="color: #0d5a8d">Paciente: {{ px.idPaciente }}</label>
        <b-form-checkbox
            v-model="px.fiscalesChecked"
            :disabled="!px.tieneFiscales"
            value="true"
            v-on:change="verCambios"
        > Datos Fiscales
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.sesionesChecked"
            :disabled="!px.tieneSesiones"
            value="true"
            v-on:change="verCambios"
        > Sesiones
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.programadosChecked"
            :disabled="!px.tieneProgramados"
            value="true"
            v-on:change="verCambios"
        > Tx Programados
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.recibosChecked"
            :disabled="!px.tieneRecibos"
            value="true"
            v-on:change="verCambios"
        > Recibos
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.pagosChecked"
            :disabled="!px.tienePagos"
            value="true"
            v-on:change="verCambios"
        > Pagos
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.facturasChecked"
            :disabled="!px.tieneFacturas"
            value="true"
            v-on:change="verCambios"
        > Facturas
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.citasChecked"
            :disabled="!px.tieneCitas"
            value="true"
            v-on:change="verCambios"
        > Citas
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.planesChecked"
            :disabled="!px.tienePlanes"
            value="true"
            v-on:change="verCambios"
        > Planes
        </b-form-checkbox>
        <b-form-checkbox
            v-model="px.historicosChecked"
            :disabled="!px.tieneHistoricos"
            value="true"
            v-on:change="verCambios"
        > PTI históricos
        </b-form-checkbox>
      </b-col>
    </b-row>



  </div>
</template>

<script>
import miniToastr from "mini-toastr";

export default {
  name: "detalleUnificacion",
  props: {
    correoOriginal: String,
    telefonos: Array,
    patientTable: Array,
    duplicados: Array,
    pacienteOriginal: Number,
    historiaSeleccionada: Number,
    kpiSeleccionado: Number,
    ptiSeleccionado: Number,
    pacienteOriginalExtranjero: Boolean,
    historiaRequerida: Boolean
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    historias: [],
    kpis:[],
    ptis:[],
    infoPacienteDuplicado: [],
    historiasNoValidas: 0,

  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerDetalleUnificacion();
    this.obtenerHistoriasClinicas();
    this.obtenerKpisPaciente();
    this.obtenerPtisPaciente();
  },

  methods:{
    verCambios(){
      this.$emit('obtenerDuplicados', this.infoPacienteDuplicado);
    },
    nuevoEmail(){
      this.$emit('obtenerEmail', this.correoOriginal);
    },
    nuevosTelefonos(){
      this.$emit('obtenerTelefonos', this.telefonos);
    },
    obtenerDetalleUnificacion() {
        if (this.duplicados.length > 0) {
          this.$http
              .post(
                  this.$api +
                  "paciente/unificacion/obtenerDetalles", this.duplicados
              )
              .then((response) => {
                if (response.status === 200) {
                  if (Array.isArray(response.data.data) == true) {
                    this.infoPacienteDuplicado = response.data.data;
                    this.$emit('obtenerDuplicados', this.infoPacienteDuplicado);
                  }
                }
              })
              .catch((error) => {
                miniToastr.info("No se encontraron pacientes");
                console.error(error);
              });
        } else {
          this.loading = false;
        }
      },
    obtenerHistoriasClinicas() {
      var pacientes = this.duplicados.map(function (item) {
        var data = {
          id: item.id,
        };
        return data;
      });
      pacientes.unshift({"id": this.pacienteOriginal})
      if (pacientes.length > 0) {
        this.$http
            .post(
                this.$api +
                "paciente/unificacion/obtenerHistorias", pacientes
            )
            .then((response) => {
              if (response.status === 200) {
                if (Array.isArray(response.data.data) == true) {
                  this.historias = response.data.data;

                  this.historias.forEach((i) => {
                    if(i.disabled){
                      this.historiasNoValidas +=1;
                    }


                      if(i.idPaciente === this.pacienteOriginal){
                        if(!i.disabled){
                          this.historiaSeleccionada = this.pacienteOriginal;
                          this.$emit('obtenerHistoria', this.historiaSeleccionada);
                        }
                      }

                  });

                  if(this.historiasNoValidas === this.historias.length){
                    this.historiaRequerida = false;
                  }else{
                    this.historiaRequerida = true;
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontró la información");
              console.error(error);
            });
      } else {
        this.loading = false;
      }
    },
    obtenerKpisPaciente() {
      var pacientes = this.duplicados.map(function (item) {
        var data = {
          id: item.id,
        };
        return data;
      });
      pacientes.unshift({"id": this.pacienteOriginal})
      if (pacientes.length > 0) {
        this.$http
            .post(
                this.$api +
                "paciente/unificacion/obtenerKpis", pacientes
            )
            .then((response) => {
              if (response.status === 200) {
                if (Array.isArray(response.data.data) == true) {
                  this.kpis = response.data.data;
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontró la información");
              console.error(error);
            });
      } else {
        this.loading = false;
      }
    },
    obtenerPtisPaciente() {
      var pacientes = this.duplicados.map(function (item) {
        var data = {
          id: item.id,
        };
        return data;
      });
      pacientes.unshift({"id": this.pacienteOriginal})
      if (pacientes.length > 0) {
        this.$http
            .post(
                this.$api +
                "paciente/unificacion/obtenerPtis", pacientes
            )
            .then((response) => {
              if (response.status === 200) {
                if (Array.isArray(response.data.data) == true) {
                  this.ptis = response.data.data;
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontró la información");
              console.error(error);
            });
      } else {
        this.loading = false;
      }
    },
    esNumero(e)
    {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    }
    },
  watch:{
    kpiSeleccionado(){
      this.$emit("obtenerKpi", this.kpiSeleccionado);
    },
    historiaSeleccionada(){
      this.$emit("obtenerHistoria", this.historiaSeleccionada);
    },
    ptiSeleccionado(){
      this.$emit("obtenerPti", this.ptiSeleccionado);
    }
  }
}
</script>

<style scoped>

</style>
